import EmitEvent, {
    BEFORE_PAGE_ENTER,
    HT_RESIZE,
    PAGE_ENTER,
    PAGE_LOADED,
    SMOOTH_SCROLLING
} from "../../../libs/emit-event";
import {ServicePageItem} from "./service-page-item";
import {isScreenPc} from "../../../libs/helper";

export class ShortcodeServicesPage {
    constructor() {
        this.DOM = {main: document.querySelector('.js-servicesPage')};
        if (!this.DOM.main) return;

        this.items = [];
        this.props = {top: 0};

        this.scrolling = this.scrolling.bind(this);
        this.pageLoaded = this.pageLoaded.bind(this);
        this.onResize = this.onResize.bind(this);
        this.pageEnter = this.pageEnter.bind(this);

        this.init();
        this.bindEvent();
    }

    init() {
        this.DOM.main.querySelectorAll('.js-servicePageItem').forEach(item => {
            this.items.push(new ServicePageItem({el: item}));
        });
    }

    scrolling({instance}) {
        if (isScreenPc()) {
            const top = this.props.top;
            this.items.forEach((item, key) => {
                item.scrolling(instance, top, (key < this.items.length - 1));
            });
        }
    }

    pageLoaded() {
        this.props.top = this.DOM.main.getBoundingClientRect().top;
        this.props.height = this.DOM.main.getBoundingClientRect().bottom;
        this.items.forEach(item => {
            item.pageEnter(this.props.top);
        });
    }

    onResize() {
        this.props.top = this.DOM.main.getBoundingClientRect().top;
        this.props.height = this.DOM.main.getBoundingClientRect().bottom;
        this.items.forEach(item => {
            item.onResize(this.props.top);
        });
    }

    pageEnter(){
        if (window.location.hash){

        }
    }

    bindEvent() {
        EmitEvent.on(HT_RESIZE, this.onResize);
        EmitEvent.on(PAGE_LOADED, this.pageLoaded);
        EmitEvent.on(SMOOTH_SCROLLING, this.scrolling);
        EmitEvent.on(PAGE_ENTER, this.pageEnter);
    }

    removeEvents() {
        if (!this.DOM.main) return;
        this.items = null;
        EmitEvent.off(HT_RESIZE, this.onResize);
        EmitEvent.off(PAGE_LOADED, this.pageLoaded);
        EmitEvent.off(SMOOTH_SCROLLING, this.scrolling);
        EmitEvent.off(PAGE_ENTER, this.pageEnter);
    }
}